<template>
  <div class="q-pa-md">
    <q-btn
      :dark="isDarkModeGlobal"
      size="sm"
      color="blue"
      flat
      @click="showNotif"
      label="About"
    />
  </div>
  <q-dialog
    :dark="isDarkModeGlobal"
    v-model="layout"
  >
    <q-card
      :dark="isDarkModeGlobal"
      style="max-width: 800px;"
    >
      <q-card-section>
        <q-tabs
          :dark="isDarkModeGlobal"
          v-model="tab"
          dense
          align="left"
          class="text-primary"
          :breakpoint="0"
        >
          <q-tab
            name="general"
          >
            General
          </q-tab>
          <q-tab
            name="analytics"
          >
            Analytics
          </q-tab>
        </q-tabs>
      </q-card-section>
      <q-card-section>
        <q-tab-panels
          :dark="isDarkModeGlobal"
          v-model="tab"
          animated
        >
          <q-tab-panel name="general">
            <q-card
              :dark="isDarkModeGlobal"
              flat
              bordered
              class="row flex q-pa-sm"
            >
              <div class="text-h5">
                TUS Calculator
                <q-badge align="middle">
                  v{{version}}
                </q-badge>

                <q-badge  :dark="isDarkModeGlobal" align="middle" class="q-ma-sm">
                  <a class="text-white" href="https://doi.org/10.17605/OSF.IO/48F2S" target="_blank">
                    DOI: 10.17605/OSF.IO/48F2S
                  </a>
                </q-badge>


              </div>
              <div style="min-width: 200px">
                <p>
                  This calculator can be used to estimate derived quantities like ultrasound intensity and mechanical index, which have consequences for both safety and efficacy of ultrasound protocols.
                </p>
                <p>
                  The fundamental frequency, pressure and temporal regime of the intended protocol must be provided as inputs.
                  Some derived parameters can also be provided as inputs. Please note that any manual changes in input parameters will automatically lead to adjustment of linked input parameters, in addition to updating of results. For instance, if MI is changed manually, the input fields for pressure amplitude, peak negative pressure and Isppa will be adjusted automatically.
                </p>
                <p>Please see the <a href="https://doi.org/10.1016/j.brs.2024.04.013" target="_blank"><strong>ITRUSST Standardised Reporting Consensus</strong></a> and <a href="https://doi.org/10.1016/j.brs.2025.10.007" target="_blank"><strong>biophysical safety reports</strong></a> for further information about each derived quantity.</p>

                <h6>Contributors</h6>
                <q-item>
                  <q-item-section side>
                    <q-avatar
                      size="48px"
                    >
                      <q-img
                        fit="contain"
                        position="0px -10px"
                        :src="photoMargely"
                        alt="Margely"
                      />
                    </q-avatar>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>
                      <a href="https://www.ru.nl/en/people/cornelissen-m">ir. Margely Cornelissen, Radboud University</a>, GitLab:
                      <a href="https://gitlab.socsci.ru.nl/margely.cornelissen">
                        @margely.cornelissen
                      </a>
                    </q-item-label>
                    <q-item-label caption />
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section side>
                    <q-avatar
                      size="48px"
                    >
                      <q-img
                        fit="contain"
                        position="0px -10px"
                        :src="photoJohn"
                        alt="John"
                      />
                    </q-avatar>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>
                      <a href="https://www.ru.nl/en/people/hal-j-van">John van Hal, Radboud University</a>, GitLab: <a href="https://gitlab.socsci.ru.nl/john.vanhal">@john.vanhal</a>
                    </q-item-label>
                    <q-item-label caption />
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section side>
                    <q-avatar
                      size="48px"
                    >
                      <q-img
                        fit="contain"
                        position="0px -10px"
                        :src="photoTulika"
                        alt="Tulika"
                      />
                    </q-avatar>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>
                      <a href="https://research.vu.nl/en/persons/tulika-nandi">Dr. Tulika Nandi, Vrije Universiteit Amsterdam</a>
                    </q-item-label>
                    <q-item-label caption />
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section side>
                    <q-avatar
                      size="48px"
                    >
                      <q-img
                        fit="contain"
                        :src="photoCarys"
                        alt="Dr. Carys Evans"
                      />
                    </q-avatar>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>
                      <a href="https://www.ru.nl/personen/evans-c">Dr. Carys Evans, Radboud University</a>
                    </q-item-label>
                    <q-item-label caption />
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section side>
                    <q-avatar
                      size="48px"
                    >
                      <q-img
                        fit="contain"
                        :src="photoLennart"
                        alt="Dr. Lennart Verhagen"
                      />
                    </q-avatar>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>
                      <a href="https://www.ru.nl/personen/verhagen-l">Dr. Lennart Verhagen, Radboud University</a>
                    </q-item-label>
                    <q-item-label caption />
                  </q-item-section>
                </q-item>

                <q-item>
                  <q-item-section side>
                    <q-avatar
                      size="48px"
                    >
                      <q-img
                        fit="contain"
                        :src="photoKim"
                        alt="Dr. Kim Butts Pauly"
                      />
                    </q-avatar>
                  </q-item-section>
                  <q-item-section>
                    <q-item-label>
                      <a href="https://profiles.stanford.edu/kim-pauly">Dr. Kim Butts Pauly, Stanford University</a>
                    </q-item-label>
                    <q-item-label caption />
                  </q-item-section>
                </q-item>
                <h6>Radboud FUS Centre</h6>
                <p>
                 This project is facilitated by the Radboud Focused Ultrasound Centre.
                  <br>
                  For more information, please visit the
                  <a
                    href="https://www.ru.nl/en/donders-institute/research/research-facilities/focused-ultrasound-initiative-fus"
                    target="_blank"
                  >
                    website.
                  </a>
                </p>

                <h6>License</h6>
                <p>
                  This project is licensed under the
                  <a
                    href="https://gitlab.socsci.ru.nl/fus-initiative/tus-calculator/-/blob/main/LICENSE"
                    target="_blank"
                  >
                    MIT License.
                  </a>
                </p>

                <h6>Feedback</h6>
                <p>
                  If you have any questions, suggestions, or feedback, please feel free to reach out to us via email at
                  <a href="mailto:fus@ru.nl">fus@ru.nl.</a>
                  <br> We'd love to hear from you and are always open to improving this project based on your input.
                </p>

                <h6>Contribute</h6>
                <p>
                  This project is open-source at <a href="https://gitlab.socsci.ru.nl/fus-initiative/tus-calculator/">
                    Socsci Gitlab
                  </a>
                  and open to contributions. Read more about
                  <a href="https://gitlab.socsci.ru.nl/fus-initiative/tus-calculator/-/blob/main/CONTRIBUTING.md">
                    contributing
                  </a>
                  to the TUS-calculator and our
                  <a
                    href="https://gitlab.socsci.ru.nl/fus-initiative/tus-calculator/-/blob/main/CODE_OF_CONDUCT.md"
                    target="_blank"
                  >
                    code of conduct.
                  </a>
                </p>
              </div>
              <q-card-section class="q-pt-none text-center" />
            </q-card>
          </q-tab-panel>

          <q-tab-panel name="analytics">
            <q-card
              flat
              bordered
              :dark="isDarkModeGlobal"
              class="q-pa-sm col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xl-6"
            >
              <usage-plot />
            </q-card>
          </q-tab-panel>
        </q-tab-panels>
      </q-card-section>

      <q-card-actions
        align="right"
        :class="isDarkModeGlobal ? 'text-primary' : 'bg-white text-primary'"
      >
        <q-btn
          flat
          label="Close"
          v-close-popup
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script setup lang="ts">
import {ref} from "vue"
import photoMargely from '../assets/contributors/MargelyCornelissen.png'
import photoJohn from '../assets/contributors/JohnVanHal.png'
import photoTulika from '../assets/contributors/TulikaNandi.webp'
import photoCarys from '../assets/contributors/CarysEvans.png'
import photoLennart from '../assets/contributors/LennartVerhagen.png'
import photoKim from '../assets/contributors/KimPauly.jpg'
import { useCalculatorStore } from '../stores/calculator.store'
import {storeToRefs} from "pinia"
import UsagePlot from "./UsagePlot.vue";
const calculatorStore = useCalculatorStore()
const {
  isDarkModeGlobal
} = storeToRefs(calculatorStore)

const tab = ref('general')
// eslint-disable-next-line no-undef
const version = APP_VERSION

const layout = ref(false)
function showNotif () {
  layout.value = true
}
</script>

